<div class="data-row">
  <div class="data-row-name">
    <div class="name-row">
      <span class="parameter font-primary-color">{{
        "features.product-overview.productDocumentsParams.documentName"
          | translate
      }}</span>
      <span class="font-secondary-color">{{ name() }}</span>
    </div>

    <span class="data-row-span">
      @if (newBadge()) {
        <span class="badge font-xs">New</span>
      }
    </span>
  </div>
  <div class="language-row">
    <span class="parameter font-primary-color">{{
      "features.product-overview.productDocumentsParams.documentLanguage"
        | translate
    }}</span>
    <span class="font-secondary-color">{{ language() }}</span>
  </div>
  <div class="format-row">
    <span class="parameter font-primary-color">{{
      "features.product-overview.productDocumentsParams.documentFormat"
        | translate
    }}</span>
    <span class="font-secondary-color">{{ format() }}</span>
  </div>
  <div class="size-row">
    <span class="parameter font-primary-color">{{
      "features.product-overview.productDocumentsParams.documentSize"
        | translate
    }}</span>
    <span class="font-secondary-color">{{ size() | claasFileSize }}</span>
  </div>
  @if (isDocumentIDOnForCurrentDocument()) {
    <div class="size-row document-id-row">
      <span class="parameter font-primary-color">{{
        "features.product-overview.productDocumentsParams.documentID"
          | translate
      }}</span>
      <span class="font-secondary-color">{{ id() }}</span>
    </div>
  }
  <div class="cta-buttons">
    <button
      class="button favorites-btn icon-only-button small"
      [ngClass]="[isDocumentFavorite() ? 'blacken' : '']"
      type="button"
      (click)="addDocumentToFavorites(id())"
    >
      <claas-icon
        [id]="''"
        [iconId]="'649123'"
        [namespace]="'storybook'"
        [iconStyle]="'bold'"
        [size]="24"
        [alt]=""
        [iconName]="'favorites'"
        [removeDefaultColor]="true"
        [class]="'favorites-icon'"
      >
      </claas-icon>
    </button>
    <a
      [href]="`${this.configService.piaAPIOrigin}/Document(${id()})/$value`"
      class="button download-btn icon-only-button small"
      (click)="handleDownloadLinkClick($event)"
      [download]="filename()"
    >
      <claas-icon
        [id]="''"
        [iconId]="'659464'"
        [namespace]="'storybook'"
        [iconStyle]="'bold'"
        [size]="24"
        [alt]=""
        [iconName]="'favorites'"
        [removeDefaultColor]="true"
        [class]="'download-icon'"
      >
      </claas-icon>
    </a>
  </div>
</div>
